import { useState, useEffect } from "react";
import Separator from "./Separator/separator";



export default function Local() {
  return (
    <section className="local" id="local">
      <div className="about-content">
      <div className="tit-sections">
          <h1>Localização</h1>
          <Separator />
          <h2>Estamos localizados na Av: Mutinga, 1249 - Sala 05 - Vila Mangalot, São Paulo - SP</h2>
        </div>
        <iframe className="local" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7318.632634534331!2d-46.74212041639538!3d-23.48511348067104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cef9636a90b9b7%3A0x8a5badaac52b98a8!2sOdontologia%20Guion!5e0!3m2!1spt-BR!2sbr!4v1741641201731!5m2!1spt-BR!2sbr"  allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </section>
  );
}